<template>
  <div class="template-wrapper">
    <div class="content-wrapper">
      <!-- Header -->
      <div class="header-bar">
        <HeaderSVG />
        <div class="header-text">{{ headerText }}</div>
      </div>

      <!-- Content -->
      <div class="content-box" :class="mediaSrc ? 'justify-center' : ''">
        <div v-if="text && mediaSrc" class="text-container pl-4" style="width: 100%">
          <p
            class="description-text"
            :style="{ fontSize: bodyTextSizeFullSreen, lineHeight: lineHeightFullScreen }"
          >
            {{ text }}
          </p>
        </div>
        <div v-if="mediaSrc" class="media-container pa-2">
          <v-img
            v-if="mediaType === 'image'"
            :src="mediaSrc"
            contain
            :style="text ? 'max-height: 300px' : 'max-height: 600px'"
          ></v-img>
          <video v-else controls class="media" :src="mediaSrc"></video>
        </div>

        <!-- Text -->
        <div
          v-if="text && !mediaSrc"
          class="text-container pa-2 pl-4"
          style="width: 100%; height: 500px"
        >
          <p
            class="description-text"
            :style="{ fontSize: bodyTextSizeFullSreen, lineHeight: lineHeightFullScreen }"
          >
            {{ text }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderSVG from "@/assets/tarjas/tropa-ge/header-bg.svg";

export default {
  props: {
    headerText: String,
    text: String,
    mediaSrc: String,
    mediaType: {
      type: String,
      default: "image", // "image" or "video"
    },
  },
  components: {
    HeaderSVG,
  },
  computed: {
    bodyTextSizeFullSreen() {
      const numChars = this.text.trim().length;
      const size =
        (numChars > 0) & (numChars <= 40)
          ? "3rem"
          : numChars > 40 && numChars <= 80
          ? "3rem"
          : numChars > 80 && numChars <= 120
          ? "2.9rem"
          : numChars > 120 && numChars <= 160
          ? "2.8rem"
          : numChars > 160 && numChars <= 200
          ? "2.7rem"
          : numChars > 200 && numChars <= 240
          ? "2.6rem"
          : numChars > 240 && numChars <= 280
          ? "2.5rem"
          : "1.5rem";
      return size;
    },
    lineHeightFullScreen() {
      const numChars = this.text.trim().length;
      const lineHeight =
        (numChars > 0) & (numChars <= 40)
          ? "3.5rem"
          : numChars > 40 && numChars <= 80
          ? "3.2rem"
          : numChars > 80 && numChars <= 120
          ? "3.1rem"
          : numChars > 120 && numChars <= 160
          ? "2.9rem"
          : numChars > 160 && numChars <= 200
          ? "2.8rem"
          : numChars > 200 && numChars <= 240
          ? "2.7rem"
          : numChars > 240 && numChars <= 280
          ? "2.8rem"
          : "1.5rem";

      return lineHeight;
    },
  },
};
</script>

<style scoped lang="scss">
@font-face {
  font-family: "HeaderText";
  src: url("@/assets/fonts/GlobotipoPlacar-Black.otf") format("opentype");
}

@font-face {
  font-family: "BodyText";
  src: url("@/assets/fonts/Globotipo-Rounded-Bold.otf") format("opentype");
}

/* Wrapper centers everything */
.template-wrapper {
  width: 100%;
  height: 100vh; // Full viewport height
  display: flex;
  justify-content: center; // Horizontal center
  align-items: center;
}

/* Inner content */
.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* Header */
.header-bar {
  position: relative;
  z-index: 100000;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    height: 120px;
    width: 705px;
  }
}

.header-text {
  position: absolute;
  left: 45px;
  top: 5px;
  color: #fff;
  font-family: "HeaderText", sans-serif;
  font-size: 2.2rem;
  text-transform: uppercase;
}

/* Content Box */
.content-box {
  position: relative;
  background: #fb0fc6;
  background: linear-gradient(
    90deg,
    rgba(251, 15, 198, 1) 0%,
    rgba(251, 15, 198, 1) 50%,
    rgba(216, 40, 66, 1) 100%
  );
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 605px;
  min-height: 500px;
  max-height: 500px;
  left: -23px;
  top: -70px;
  // box-shadow: 1px 1px 10px #464747;
}

/* Media */
.media-container {
  width: 100%;
  display: flex;
  justify-content: center;
}
.media {
  max-width: 100%;
  border-radius: 4px;
}

/* Text */

.text-container {
  display: flex;
  flex-direction: column;
  justify-content: center; /* vertical center */
  align-items: flex-start; /* keep left alignment */
}

.text-container .description-text {
  margin-top: 15px;
  font-family: "BodyText", sans-serif;
  color: rgb(255, 255, 255);
  word-break: break-all;
}
</style>
